import { SolutionMap } from "@labs/shared/types/Solution.ts";
import { AnalyzedPlan } from "@labs/shared/types/AnalyzedPlan.ts";
import { Target } from "@labs/shared/types/Target.ts";
import { EmissionsBySource } from "@labs/shared/types/EmissionsBySource.ts";
import { EmailLambdaRequestBody } from "@labs/shared/types/EmailLambdaRequestBody.ts";
import { User } from "@labs/shared/types/User.ts";
import { commercialAndIndustrialOptions } from "../data/industryTypeOptions.ts";
import { getEmailLambdaUrl } from "./getEmailLambdaUrl.ts";

export const callEmailLambda = async (
  user: User,
  baselineEmissions: EmissionsBySource,
  solutionMap: SolutionMap,
  target: Target,
  analyzedPlan: AnalyzedPlan,
) => {
  const readableIndustryType =
    commercialAndIndustrialOptions.find((o) => o.value === user.industryType)
      ?.label ||
    user.industryType ||
    "unknown industry";
  const userWithReadableIndustry = {
    ...user,
    readableIndustryType,
  };

  const emailLambdaRequestBody: EmailLambdaRequestBody = {
    user: userWithReadableIndustry,
    baselineEmissions,
    solutionMap,
    target,
    analyzedPlan,
  };

  const emailLambdaUrl = getEmailLambdaUrl();
  const response = await fetch(emailLambdaUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": emailLambdaUrl,
    },
    body: JSON.stringify(emailLambdaRequestBody),
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  const result = await response.json();
  console.log("Email sent successfully:", result);
};
